import React, { useState, useEffect, CSSProperties  } from "react";
import { useAuth } from "../../auth/AutoContextProvider";
import { css } from "@emotion/react";
import { MoonLoader } from "react-spinners";

const RefreshAuthenticationModal = () => {
    const [timeLeft, setTimeLeft] = useState(10);
    const [_, {sso, getInitialGuestToken, getFinalGuestToken}] = useAuth()

    useEffect(() => {
      const interval = setInterval(() => {
        if (timeLeft > 0) {
          setTimeLeft((prevTime) => prevTime - 1);
        } else {
          clearInterval(interval);
          window.location.href = process.env.REACT_APP_WEBFLOW_HOME_LINK;
        }
      }, 1000);
  
      return () => clearInterval(interval);
    }, [timeLeft]);

    const refreshAuthentication = async() => {
      await getInitialGuestToken()
      .then(url => {
        getFinalGuestToken(url.refresh_token)
        .then(data=>{
          sso(data.token,data.refresh_token,data.role)
        })
      })
    }

    return (
      <div className="fixed z-10 inset-0 overflow-y-auto">
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <div className="fixed inset-0 transition-opacity">
            <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
          <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
            <div className="bg-white-700 px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div className="sm:flex sm:items-start justify-center">
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                </div>
              </div>
            </div>
            <div className="bg-white-700 px-4 py-3 sm:px-6 sm:flex sm:flex-col">
              <div className="flex flex-row  w-full justify-center p-5">
                <span className="font-bold text-[1.5rem] p-5 text-center">Warning: Your session will expire in</span>
              </div>
              <div className="flex flex-row w-full justify-center">
                <div className="flex h-full w-full z-[9999] top-0 left-0 justify-center align-center">
                    {/* <MoonLoader size={50} color={"#36D7B7"} loading={true} speedMultiplier={0.5} /> */}
                    <span className="font-bold text-[1.5rem] p-5 text-center">{timeLeft}</span>
                </div>
              </div>
              <div className="flex flex-row  w-full justify-center p-5">
                <span className="font-bold text-[1.5rem] p-5 text-center">Click the refresh button to continue</span>
              </div>
              <div className="flex flex-row  w-full justify-center p-5">
                <button className="bg-white-500 hover:bg-gray-300  border-[2px] border-themeColor-100 text-themeColor-200 font-bold py-2 px-4 rounded-full" onClick={refreshAuthentication}>
                  Refresh
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}

export default RefreshAuthenticationModal